import React, { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';

const SMSUsageBar = () => {
  const { user } = useAuth();
  
  console.log('SMSUsageBar user data:', user);
  
  // Format dates for display
  const formatDate = (dateString) => {
    if (!dateString) {
      console.log('formatDate: No date string provided');
      return 'Not set';
    }
    
    try {
      console.log('formatDate: Attempting to format date:', dateString);
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        console.log('formatDate: Invalid date:', dateString);
        return 'Not set';
      }
      
      return date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      });
    } catch (error) {
      console.error('Error formatting date:', error);
      return 'Not set';
    }
  };
  
  // Calculate SMS usage data - must be called unconditionally
  const smsUsageData = useMemo(() => {
    // Skip for admin users
    if (!user) {
      console.log('SMSUsageBar: No user data available');
      return null;
    }
    
    if (user?.role === 'admin') {
      console.log('SMSUsageBar: Admin user, skipping usage display');
      return null;
    }
    
    const used = user?.smsUsage?.monthly || 0;
    const rawLimit = user?.smsLimit;
    // Only consider it a limit if it's a positive number
    const hasLimit = rawLimit !== null && rawLimit !== undefined && rawLimit > 0;
    const limit = hasLimit ? rawLimit : 'Unlimited';
    const usagePercent = hasLimit ? Math.min(100, Math.round((used / rawLimit) * 100)) : 0;
    
    // Get dates with fallbacks
    const startDate = user?.smsStartDate || null;
    const resetDate = user?.smsResetDate || null;
    
    console.log('SMS Usage data:', { 
      used, 
      limit, 
      hasLimit, 
      usagePercent, 
      rawLimit, 
      startDate, 
      resetDate,
      rawStartDate: user?.smsStartDate,
      rawResetDate: user?.smsResetDate,
      userObject: JSON.stringify(user)
    });
    
    return { used, limit, hasLimit, usagePercent, rawLimit, startDate, resetDate };
  }, [user]);
  
  // Skip rendering for admin users or when data is not available
  if (!smsUsageData) return null;
  
  // Determine progress bar color based on usage
  const getProgressColor = () => {
    if (!smsUsageData.hasLimit) return 'bg-green-500'; // Unlimited
    
    const { usagePercent } = smsUsageData;
    if (usagePercent >= 90) return 'bg-red-500';
    if (usagePercent >= 75) return 'bg-yellow-500';
    return 'bg-green-500';
  };
  
  return (
    <div className="px-4 py-2 bg-white border-b">
      <div className="flex justify-between items-center mb-1">
        <div className="text-sm font-medium">
          SMS Usage: {smsUsageData.used} {smsUsageData.hasLimit ? `/ ${smsUsageData.limit}` : '(Unlimited)'}
        </div>
        <div className="text-xs text-gray-500">
          {smsUsageData.hasLimit ? `Resets: ${formatDate(smsUsageData.resetDate)}` : 'No limit'}
        </div>
      </div>
      
      {smsUsageData.hasLimit && (
        <div className="w-full bg-gray-200 rounded-full h-2.5">
          <div 
            className={`h-2.5 rounded-full ${getProgressColor()}`} 
            style={{ width: `${smsUsageData.usagePercent}%` }}
          ></div>
        </div>
      )}
      
      <div className="flex justify-between items-center mt-1">
        <div className="text-xs text-gray-500">
          Cycle Start: {formatDate(smsUsageData.startDate)}
        </div>
        <div className="text-xs text-gray-500">
          Next Reset: {formatDate(smsUsageData.resetDate)}
        </div>
      </div>
    </div>
  );
};

export default SMSUsageBar; 